/** @format */

import React from 'react';
import TemplateButton from './TemplateButton.js';
import PropTypes from 'prop-types';
import { ReactComponent as Sim } from '../../assets/themes/OPL/img/icons/Sim.svg';

function SimCardButton({ ...props }) {
    const { classes, callback, callbackParam, color, text, ...rest } = props;
    return (
        <TemplateButton
            {...rest}
            className={classes}
            classes={classes}
            icon={Sim}
            color={color}
            callback={callback}
            callbackParam={callbackParam}
            text={text}
        />
    );
}

SimCardButton.propTypes = {
    callback: PropTypes.func.isRequired,
    callbackParam: PropTypes.object.isRequired,
    color: PropTypes.string,
    text: PropTypes.string,
};

export default SimCardButton;
